import { getChache, setCacheDalayed } from '../util/localStorage'

const LOCAL_STORAGE_KEY = 'cached-redux-state'

export function getChachedState() {
    return getChache(LOCAL_STORAGE_KEY) || {}
}

const setCachedState = setCacheDalayed(LOCAL_STORAGE_KEY)

export const cacheStateMidleware = store => next => (action) => {
    next(action)

    const { map, filter } = store.getState()

    setCachedState({ map, filter })
}
